import { Capacitor } from '@capacitor/core';

// iPad should use the same responsive web UX as Safari inside Capacitor.
const USE_BROWSER_STYLE_IPAD_UI = true;

export interface NativeDeviceProfile {
  isNativeRuntime: boolean;
  isNativeIOS: boolean;
  isNativeAndroid: boolean;
  isIPad: boolean;
  isIPhone: boolean;
  isNativeIPad: boolean;
  isNativePhone: boolean;
}

function getScreenMaxDimension(): number {
  if (typeof window === 'undefined' || !window.screen) return 0;
  return Math.max(window.screen.width || 0, window.screen.height || 0);
}

function detectAppleDevice() {
  if (typeof navigator === 'undefined') {
    return {
      isIOS: false,
      isIPad: false,
      isIPhone: false,
    };
  }

  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;
  const screenMaxDimension = getScreenMaxDimension();

  const isIPhone = /iPhone|iPod/i.test(userAgent);
  const isIPadFromUA = /iPad/i.test(userAgent);
  const isTouchMac = /Mac/i.test(platform) && maxTouchPoints > 1;
  const isIOS = isIPhone || isIPadFromUA || isTouchMac;
  const isIPad = isIPadFromUA || isTouchMac || (isIOS && screenMaxDimension >= 1024 && !isIPhone);

  return {
    isIOS,
    isIPad,
    isIPhone: isIOS && !isIPad,
  };
}

export function getNativeDeviceProfile(): NativeDeviceProfile {
  const { isIOS, isIPad, isIPhone } = detectAppleDevice();
  const isNativeRuntime = Capacitor.isNativePlatform();
  const nativePlatform = isNativeRuntime ? Capacitor.getPlatform() : 'web';

  const isNativeIOS = isNativeRuntime && nativePlatform === 'ios';
  const isNativeAndroid = isNativeRuntime && nativePlatform === 'android';
  const isNativeIPad = isNativeIOS && isIPad && !USE_BROWSER_STYLE_IPAD_UI;
  const isNativePhone = (isNativeIOS && isIPhone) || isNativeAndroid;

  return {
    isNativeRuntime,
    isNativeIOS,
    isNativeAndroid,
    isIPad,
    isIPhone,
    isNativeIPad,
    isNativePhone,
  };
}
